// extracted by mini-css-extract-plugin
export default {"TransactionPage":"FormWrapper_TransactionPage__gZ2le","navBack":"FormWrapper_navBack__-WPM0","wrapper":"FormWrapper_wrapper__ZPne2"};